import { render, staticRenderFns } from "./myCommsPage.vue?vue&type=template&id=407853db&scoped=true&"
import script from "./myCommsPage.vue?vue&type=script&lang=ts&"
export * from "./myCommsPage.vue?vue&type=script&lang=ts&"
import style0 from "./myCommsPage.vue?vue&type=style&index=0&id=407853db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407853db",
  null
  
)

export default component.exports